import { Route } from 'react-router-dom'

import { BrokerCarrierRelationshipEdit } from 'components/Brokers/BrokerCarrierRelationshipEdit'
import { EquipmentInspectionReportButton } from 'components/Equipment/EquipmentInspectionReportCreateUpdateButton'
import { ApproveJobV2 } from 'components/Jobs/ApproveJobV2'
import { ExternalBook } from 'components/Jobs/ExternalBook'
import ScheduleInspect from 'components/Schedules/ScheduleInspect'
import { SFMSHomepageShow } from 'components/SFMS/SFMSHomepageShow'
import TeamProductChange from 'components/Teams/TeamProductChange'
import TrailerInvoiceParsing from './components/EquipmentManagement/TrailerInvoiceParsing'
import GenerateInvoiceForm from './components/Invoices/GenerateInvoice'
import InvoiceEditNotes from './components/Invoices/InvoiceEditNotes'
import ApproveJob from './components/Jobs/ApproveJob'
import AutoBidForm from './components/Loads/AutoBidForm'
import BookLoadForm from './components/Loads/BookLoad'
import { PolicyAdd } from './components/Policies/PolicyAdd'
import { PolicyDetails } from './components/Policies/PolicyDetails'
import { PolicyEdit } from './components/Policies/PolicyEdit'
import { PolicyRefinance } from './components/Policies/PolicyRefinance'
import ComplianceDocumentsList from './components/SafetyTool/ComplianceDocumentsList'
import { SafetyToolUser } from './components/SafetyTool/SafetyToolUser/SafetyToolUser'
import ScheduleGenerate from './components/Schedules/ScheduleGenerate'
import StatementCreate from './components/Statements/StatementCreate'

export default [
  <Route exact path="/loads/:id/book" component={BookLoadForm} />,
  <Route exact path="/contacted-loads/:id/book" component={BookLoadForm} />,
  <Route exact path="/loads/:id/auto-bid" component={AutoBidForm} />,
  <Route exact path="/schedules/generate" component={ScheduleGenerate} />,
  <Route exact path="/jobs/:id/approve" component={ApproveJob} />,
  <Route exact path="/jobs/:id/approve-v2" component={ApproveJobV2} />,
  <Route exact path="/jobs/:id/correction" component={StatementCreate} />,
  <Route exact path="/jobs/:id/invoice/:verifyDelivery?" component={GenerateInvoiceForm} />,
  <Route exact path="/teams/:id/request-bundle-change" component={TeamProductChange} />,
  <Route exact path="/invoices/:id/notes" component={InvoiceEditNotes} />,
  <Route exact path="/compliance-documents-management" component={ComplianceDocumentsList} />,
  <Route exact path="/trailer-invoice-parser" component={TrailerInvoiceParsing} />,
  <Route exact path="/external-book" component={ExternalBook} />,
  <Route exact path="/teams/:teamId/policy/add" component={PolicyAdd} />,
  <Route exact path="/teams/:teamId/policy/details/:id" component={PolicyDetails} />,
  <Route exact path="/teams/:teamId/policy/details/:id/refinance" component={PolicyRefinance} />,
  <Route exact path="/teams/:teamId/policy/edit/:id" component={PolicyEdit} />,
  <Route
    exact
    path="/teams/:teamId/show/:equipmentType/:equipmentId/equipment-inspection-report/"
    component={EquipmentInspectionReportButton}
  />,
  <Route exact path="/sfms/homepage/:id/show" component={SFMSHomepageShow} />,
  <Route exact path="/broker-carrier-relationships/:id" component={BrokerCarrierRelationshipEdit} />,
  <Route exact path="/jobs/:jobId/schedules/:scheduleId/inspect" component={ScheduleInspect} />,
  <Route exact path="/compliance-safety-tool/:userId" component={SafetyToolUser} />,
]
